import { render, staticRenderFns } from "./badWords.vue?vue&type=template&id=39a1a826&scoped=true"
import script from "./badWords.vue?vue&type=script&lang=js"
export * from "./badWords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a1a826",
  null
  
)

export default component.exports